// Component for the Sign In View
import { InputField } from "./InputField";
import { Lock, Mail } from 'lucide-react'; 
export const SignInView = ({ email, password, generalError, passwordError, isShaking, handleEmailChange, handlePasswordChange, handleSubmit, setCurrentView, clearErrors }) => (
    // We keep the transition wrapper for the fade effect
    <div key="sign-in-view" className="transition duration-500 ease-in-out transform animate-fade-in">
      <h2 className="text-2xl font-semibold text-slate-50 mb-2">Sign in</h2>
      <p className="text-slate-400 mb-8 text-sm">Enter your email and password to access your account.</p>

      {/* Conditional error message block (uses generalError) */}
      {generalError && (
        <div className="mb-6 p-3 rounded-lg bg-red-900/50 border border-red-700 text-red-300 text-sm animate-fade-in">
          <p className="font-medium text-center tracking-wide">{generalError}</p>
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-6">
        
        {/* Email Field - Uses handleEmailChange */}
        <div className="group">
          <label htmlFor="email" className="block text-sm font-medium text-slate-100 tracking-wide mb-1">
            EMAIL ADDRESS
          </label>
          <InputField
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            placeholder="identity@knoesis.co.uk"
            Icon={Mail}
            value={email}
            onChange={handleEmailChange}
            hasError={false} 
          />
        </div>

        {/* Password Field - Uses handlePasswordChange */}
        <div className="group">
          <label htmlFor="password" className="block text-sm font-medium text-slate-100 tracking-wide mb-1">
            PASSWORD
          </label>
          <InputField
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            placeholder="********"
            Icon={Lock}
            value={password}
            onChange={handlePasswordChange}
            hasError={isShaking} 
          />
          {/* Specific password error message */}
          {passwordError && (
            <p className="mt-1.5 text-xs text-red-400 animate-fade-in">
              {passwordError}
            </p>
          )}
        </div>
        
        {/* Submit Button */}
        <div className="pt-4">
          <button
            type="submit"
            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-md font-semibold text-slate-100 
                       bg-slate-700 hover:bg-slate-600 
                       hover:drop-shadow-[0_0_5px_rgba(203,213,225,0.2)] 
                       active:bg-gradient-to-br active:from-slate-700 active:to-slate-800 
                       focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-500 focus:ring-offset-slate-900 
                       transition duration-300 uppercase tracking-wide"
          >
            LOGIN
          </button>
        </div>

        {/* Forgot Password - Moved Below Button and Centered */}
        <div className="text-center pt-2">
          <button 
            type="button" 
            onClick={() => { setCurrentView('forgotPassword'); clearErrors(); }}
            className="text-sm font-medium text-slate-100 hover:text-slate-300 transition duration-300"
          >
            Forgot Password?
          </button>
        </div>

        {/* Legal Disclaimer Added Here */}
        <p className="mt-4 text-xs text-center text-slate-500 leading-relaxed">
          By initiating access to the DANTE interface, you hereby agree to comply with and be bound by the{' '}
          <a 
            href="https://partners.knoesis.co.uk/legal/terms" 
            target="_blank" 
            rel="noopener noreferrer"
            className="underline text-white font-bold hover:text-slate-300 transition-colors duration-200"
          >
            Terms and Conditions
          </a>
          , and acknowledge that your data will be processed in accordance with our{' '}
          <a 
            href="https://partners.knoesis.co.uk/legal/privacy" 
            target="_blank" 
            rel="noopener noreferrer"
            className="underline text-white font-bold hover:text-slate-300 transition-colors duration-200"
          >
            Privacy Policy
          </a>.
        </p>

      </form>
    </div>
);